import { StyleSheet } from "react-native";

export default StyleSheet.create({
    modalContainer: {
        flex: 1,
        padding: 20,
    },
    modalItem: {
        backgroundColor: 'white',
        padding: 16,
    },
    modalItemText: {
        fontSize: 16,
        color: '#374151',
    },
    modalHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: 16,
        borderBottomWidth: 1,
        borderBottomColor: '#e5e7eb',
    },
    modalTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        color: '#374151',
    },
    modalItemBadge: {
        fontSize: 12,
        color: '#6b7280',
        backgroundColor: '#f3f4f6',
        paddingHorizontal: 8,
        paddingVertical: 2,
        borderRadius: 4,
        marginLeft: 8,
    },
    modalItemContent: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    optionContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    optionButton: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 16,
    },
    optionText: {
      fontSize: 18,
      color: '#374151',
      fontWeight: '600',
      flex: 1,
    },
    optionPlaceholder: {
      fontSize: 18,
      color: '#9ca3af',
      fontWeight: '500',
      flex: 1,
    },
})
